import Vue from 'vue';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import VueLazyload from "vue-lazyload";

Vue.use(Vuex);
Vue.use(VueLazyload);
Vue.filter('toNow', (time) => {
    if(!time) {
        return '';
    }
    return moment(time * 1000).toNow();
});
Vue.filter('timeago', (time) => {
    if(!time) {
        return '';
    }
    return moment(time * 1000).fromNow();
});
Vue.filter('format', (date, type) => {
    return moment(date, 'YYYY-MM-DD').format(type);
});

window.Vue = Vue;
window.Vuex = Vuex;
window.VueRouter = VueRouter;
window.eventBus = window.EventBus = window.events = new Vue();
